<div class="account">
  <div class="content">
    <img 
      src="/assets/icons/back-arrow.svg" 
      alt="back btn" 
      class="back-btn"
      (click)="onBackClick()"
    />
    <h2 class="heading">Verify Account</h2>
  </div>
  <div class="verify-details">
    <p>A verification code has been sent to: <br/>
      l*******&#64;email.com</p>

    <p class="code-link"><a href="">Send new code</a></p>

    <p class="verify-para">Enter verification code</p>
    
    <div class="code-div">
      <ng-otp-input [config]="otpConfig"></ng-otp-input>
    </div>
    
    <button 
      mat-flat-button 
      type="button" 
      class="verify-btn"
    >
      Verify
    </button>
  </div>
</div>